import { cn } from "design-system/utils"
import { SendHorizonal } from "lucide-react"
import whatsappBg from "../whatsapp/image.png"

type Props = {
  text: string
  identifier: string
  className?: string
}

export const WhatsappOpeningMessagePreview = ({ text, identifier, className }: Props) => {
  return (
    <div
      className={cn(
        "bg-emerald-50 dark:bg-emerald-900 w-full min-h-20 relative text-start text-wrap col-span-2 rounded-md overflow-hidden flex items-end",
        className,
      )}
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-10 z-0 dark:opacity-20"
        style={{ backgroundImage: `url(${whatsappBg})` }}
      />
      <div className="py-2 px-4 bg-gray-100 relative z-10 w-full flex gap-2 mt-4">
        <div
          className={
            "flex flex-col gap-2 bg-white dark:bg-secondary text-sm rounded-lg border border-border p-2 grow"
          }
        >
          <span className="whitespace-pre-wrap">{text.replace("{{identifier}}", identifier)}</span>
        </div>
        <div className="bg-green-500 text-white items-center justify-center flex min-w-[40px] h-[40px] rounded-full self-end">
          <SendHorizonal className="ml-1" />
        </div>
      </div>
    </div>
  )
}
